const { useSelector } = require("react-redux");

export default function useUser() {
  const user = useSelector((state) => state.account);

  return user;
}
